import { Component, HostListener } from '@angular/core';
import { UserManagementService } from '../../../shared/services/user-management.service';
import { AuthService } from '../../../shared/services/auth.service';
import { Observable, of, Subject } from 'rxjs';
import { UploadFilesService } from '../../services/upload-files.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CanComponentDeactivate } from '../../models/files';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrl: './upload.component.scss',
})
export class UploadComponent implements CanComponentDeactivate {
  hasTargetColumnMapping: boolean | null = null;

  @HostListener('window:beforeunload', ['$event'])
  beforeUnload(event: BeforeUnloadEvent): void {
    if (
      this.uploadFilesService.isFileUploaded &&
      (!this.uploadFilesService.isFilePublished || !this.uploadFilesService.isFileProcessed)
    ) {
      event.preventDefault();
      event.returnValue = '';
    }
  }

  constructor(
    private userManagement: UserManagementService,
    private authService: AuthService,
    private uploadFilesService: UploadFilesService,
    private nzModalService: NzModalService,
  ) {
    this.hasTargetColumnMapping = this.authService.hasTargetColumnMappingEmpty(this.userManagement.getOrgId());
  }

  canDeactivate(): Observable<boolean> {
    if (
      this.uploadFilesService.isFileUploaded &&
      (!this.uploadFilesService.isFilePublished || !this.uploadFilesService.isFileProcessed)
    ) {
      const result = new Subject<boolean>();

      this.nzModalService.confirm({
        nzTitle: '<i>Do want to leave unfinished task?</i>',
        nzContent: "<b>You haven't published or processed file, complete process and publish before leaving</b>",
        nzOnOk: () => {
          result.next(true);
          result.complete();
        },
        nzOnCancel: () => {
          result.next(false);
          result.complete();
        },
      });

      return result.asObservable();
    }
    return of(true);
  }
}
